/** True when the body holds visible text, a variable or an image, not just empty markup. */
export function hasBodyContent(bodyHtml: string): boolean {
  if (/<img\b/i.test(bodyHtml)) return true;
  const text = bodyHtml.replace(/<[^>]*>/g, '').replace(/&nbsp;|&#160;/g, ' ');
  return text.trim() !== '';
}
